/**
 * Quick Prompt Library for the AI Mentor.
 *
 * Each prompt has:
 * - id: unique key
 * - icon: emoji displayed on the chip
 * - labelKey: i18n key for the display label
 * - template: the text injected into the composer ({{placeholder}} for user input)
 * - requiresInput: whether to show an inline input before inserting
 * - inputPlaceholder: i18n key for the input placeholder
 * - inputField: the template placeholder name to replace
 */
export const QUICK_PROMPTS = [
  {
    id: 'summarize_chapter',
    icon: '📋',
    labelKey: 'ai.quickPrompts.summarizeChapter',
    template: 'Summarize chapter {{chapter}} — key events, character arcs, and unresolved threads.',
    requiresInput: true,
    inputPlaceholder: 'ai.quickPrompts.chapterNumberPlaceholder',
    inputField: 'chapter',
  },
  {
    id: 'continue_story',
    icon: '✍️',
    labelKey: 'ai.quickPrompts.continueStory',
    template: 'Continue the story from where the last chapter left off. Maintain tone and open threads.',
    requiresInput: false,
  },
  {
    id: 'character_profile',
    icon: '👤',
    labelKey: 'ai.quickPrompts.characterProfile',
    template: 'Give me a full profile of {{character}} — appearance, personality, arc so far, and relationships.',
    requiresInput: true,
    inputPlaceholder: 'ai.quickPrompts.characterNamePlaceholder',
    inputField: 'character',
  },
  {
    id: 'plot_holes',
    icon: '🔍',
    labelKey: 'ai.quickPrompts.findPlotHoles',
    template: 'Review the manuscript for plot holes, inconsistencies, and unresolved story threads.',
    requiresInput: false,
  },
  {
    id: 'chapter_outline',
    icon: '📝',
    labelKey: 'ai.quickPrompts.outlineNextChapter',
    template: 'Outline the next chapter based on open threads and story momentum.',
    requiresInput: false,
  },
  {
    id: 'story_timeline',
    icon: '📅',
    labelKey: 'ai.quickPrompts.storyTimeline',
    template: 'Build a timeline of key events across the manuscript so far.',
    requiresInput: false,
  },
  {
    id: 'scene_suggestion',
    icon: '🎬',
    labelKey: 'ai.quickPrompts.suggestScene',
    template: 'Suggest a compelling scene that advances the story and develops {{character}}.',
    requiresInput: true,
    inputPlaceholder: 'ai.quickPrompts.characterNamePlaceholder',
    inputField: 'character',
  },
  {
    id: 'writing_feedback',
    icon: '💬',
    labelKey: 'ai.quickPrompts.writingFeedback',
    template: 'Give writing feedback on the current chapter — pacing, dialogue, description, and voice.',
    requiresInput: false,
  },
];
